import { faTimes } from "@awesome.me/kit-cae4660dd3/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as React from "react";
import { Badge, OverlayTrigger } from "react-bootstrap";
import Popover from "react-bootstrap/esm/Popover";
import { StandardCode } from "./lesson-information-modal-types";
import "./standards.scss";

export const getStandardCodes = (standardCodes: StandardCode[]): string | string[] => {
  return isValid(standardCodes)
    ? sortStandardCodes(standardCodes)
        .filter((item, index, codes) => codes.findIndex((codeItem) => codeItem.code === item.code) === index)
        .map((item) => item.code)
    : "N/A";
};

export const sortStandardCodes = (standardCodes: StandardCode[]) => {
  return standardCodes.sort((a, b) => a.code.localeCompare(b.code));
};

export const isValid = (standardCodes: StandardCode[]): boolean => {
  return !!standardCodes && standardCodes.length > 0;
};

export const getStandard = (standard: string, standardCodes: StandardCode[], className?: string) => {
  const filteredStandard = standardCodes.filter((item) => standard === item.code) as unknown as StandardCode[];
  const sortedStandards = sortStandardCodes(filteredStandard);
  return (
    <Popover
      id="popover-single-standard-code"
      data-testid="popover-standard-test-id"
      className={className ? className : "tile-standard__tooltip"}
    >
      {isValid(filteredStandard) ? (
        sortedStandards.length > 1 ? (
          <div className="tile-standard__items">
            {sortedStandards.map((item: any) => {
              // multiple standards we display code and description
              // single standard we display only description
              return (
                <div
                  key={item.code}
                  className="tile-standard__tooltip__item"
                  data-testid="tile-standard__tooltip__item"
                >
                  <p>
                    {item.description.length ? (
                      <>
                        <strong>{item.code}</strong>
                        <br />
                        {item.description}
                      </>
                    ) : (
                      "No description available"
                    )}
                  </p>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="tile-standard__tooltip__item" data-testid="tile-standard__tooltip__item">
            <p>
              {sortedStandards[0].description.length ? (
                <>{sortedStandards[0].description}</>
              ) : (
                "No description available"
              )}
            </p>
          </div>
        )
      ) : (
        <div className="tile-standard__tooltip__item" data-testid="tile-standard__tooltip__item">
          <p>No standard identified</p>
        </div>
      )}
    </Popover>
  );
};

export const getMoreStandard = (standardCodes: StandardCode[]) => {
  const filteredStandard = standardCodes.slice(1) as unknown as StandardCode[];
  return (
    <Popover
      id="popover-multi-standard-codes"
      data-testid="popover-standards-test-id"
      className="tile-standard__tooltip"
    >
      {isValid(filteredStandard) && (
        <div className="tile-standard__items">
          <span className="tile-standard__tooltip__close" role="presentation" onClick={() => document.body.click()}>
            <FontAwesomeIcon icon={faTimes} aria-label="close" />
          </span>
          {sortStandardCodes(filteredStandard).map((item: any) => (
            <div key={item.code} className="tile-standard__tooltip__item">
              <h6>{item.code}</h6>
              <p>{item.description}</p>
            </div>
          ))}
        </div>
      )}
    </Popover>
  );
};

export const getStandardCodesForTile = (standardCodes: StandardCode[]) => {
  let codes: any[] = [];
  let allStandardCodes: any[] = [];
  if (!!standardCodes && standardCodes.length > 0) {
    codes = standardCodes.map((standardCode) => (
      <React.Fragment key={standardCode.code}>
        <OverlayTrigger placement="bottom-start" overlay={getStandard(standardCode.code, standardCodes)}>
          <span className="standard-container__box">{standardCode.code}</span>
        </OverlayTrigger>
      </React.Fragment>
    ));

    allStandardCodes = standardCodes.map((item) => {
      return { title: item.code, eventKey: item.code, content: item.description };
    });
  }
  return (
    <div className="standard-container">
      <h2 className="standard-subtitle">Standards</h2>
      <div className="standard-container__boxes">{codes}</div>
      {allStandardCodes.length == 0 && <p className="standard-description">No Standards available.</p>}
    </div>
  );
};

export const Standard_Click = (standardData: string[], standardCodes: StandardCode[]) => {
  return (
    <OverlayTrigger trigger="click" placement="bottom" rootClose={true} overlay={getMoreStandard(standardCodes)}>
      <div className="tile-standard__count">+{standardData.length - 1}</div>
    </OverlayTrigger>
  );
};
